import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lang]/intro/ad-provider/ad-provider.client.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/[lang]/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/analytics/analytics-provider/client-attributes.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/analytics/web-vitals/web-vital.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserInteractionProviderClient"] */ "/app/app/components/load-on-interaction/interaction-provider-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoadOnUserInteractionClient"] */ "/app/app/components/load-on-interaction/load-on-interaction-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/session-attributes/session-attributes-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/script/meta-pixel/meta-pixel-time-spent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AdBlockCheck"] */ "/app/node_modules/@gamezop/ads-sdk/dist/esm/ad-block-check/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ConsentProviderClient"] */ "/app/node_modules/@gamezop/ads-sdk/dist/esm/consent-v2/index.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@gamezop/ads-sdk/dist/esm/id5/index.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["GamInterstitialScript"] */ "/app/node_modules/@gamezop/ads-sdk/dist/esm/interstitial-ad/gam-interstitial-script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@gamezop/ads-sdk/dist/esm/script/consent-script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@gamezop/ads-sdk/dist/esm/script/lazyload-scripts.js");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsClientProvider"] */ "/app/node_modules/@gamezop/analytics-sdk/dist/esm/client/context/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@gamezop/analytics-sdk/dist/esm/client/provider/custom-event.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@gamezop/analytics-sdk/dist/esm/client/provider/lazy-load.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/[lang]/layout.tsx\",\"import\":\"Roboto\",\"arguments\":[{\"style\":\"normal\",\"weight\":[\"400\",\"500\",\"700\"],\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"robotoLatin\"}");
